import React from 'react';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faToolbox } from "@fortawesome/free-solid-svg-icons";


const ReportSettings = () => {
  return (
    <div>
      <h1>Report Settings</h1>
      {/* Add your settings form or components here */}
      <div>
        <span className="text-gray-600">
          <FontAwesomeIcon icon={faToolbox} className="mr-2" />
          Manage your report settings here.
        </span>``
      </div>
    </div>
  );
};

export default ReportSettings;